module.exports = __webpack_public_path__ + "static/img/sbwb-title1.353aa6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/xiayan/assets/img/sbwb-title1.png
// module id = 2gWp
// module chunks = 1